import React, { createContext, useState, useContext, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';

const AlertContext = createContext(null);

export const useAlert = () => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error('useAlert must be used within an AlertProvider');
  }
  return context;
};

export const AlertProvider = ({ children }) => {
  /**
   * Alert Object Structure:
   * {
   *   id: string,
   *   message: string,
   *   severity: 'info' | 'warning' | 'error' | 'success',
   *   icon: ReactNode (optional override),
   *   action: {
   *     label: string,
   *     onClick: function
   *   }
   * }
   */
  const [alert, setAlert] = useState(null);

  const clearAlert = useCallback(() => {
    setAlert(null);
  }, []);

  const value = useMemo(() => ({
    alert,
    setAlert,
    clearAlert
  }), [alert, clearAlert]);

  return (
    <AlertContext.Provider value={value}>
      {children}
    </AlertContext.Provider>
  );
};

AlertProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AlertContext;